var _ = require('lodash')

var Media = function(media, width, height, prepend = false, is_folder = false) {
    var ths = this
    var host = window.location.hostname

    // Properties
    this.width = width
    this.height = height
    this.media_type = media.media_type
    this.order = media.order
    this.title = media.title
    this.is_folder = is_folder
    this.size = media.size ? media.size : -1
    this.non_viewable = media.non_viewable ? media.non_viewable : false
    this.description = media.description
    this.is_graphic = this.description.match(/[^a-zA-Z]graphic([^a-zA-Z]|$)/i)
    this.is_graphic = /\bGraphic Content Warning\b/i.test(this.description);

    // Paths
    this.full_path = media.path.replace(/\\/g, '/')

    if (prepend) {
        this.full_path = '/media/' + this.full_path
    }

    this.encoded_full_path = encodeURI(this.full_path)
    this.google_path = "http://docs.google.com/gview?url=http://"+host+this.encoded_full_path+"&embedded=true"

    // For openseadragon
    this.url = this.encoded_full_path

    // Non-Images, Non-pdfs that is larger 25MB are download only
    this.type = (function () {
        if (media.type != 'image' && media.type != 'pdf') {
            return (ths.size/1024/1024) > 25 ? 'downloadable' : media.type
        }

        return media.type
    })()

    this.thumbnail_path = (function () {
        var route = '/img'
        if (ths.type == 'pdf') {
            var route = '/pdf'
        }

        // We can't/don't need to make a thumbnail out of svg
        if (ths.type == 'svg') {
            return ths.full_path
        }

        // If not image or pdf use static thumbnail
        if (ths.type != 'image' && ths.type != 'pdf') {
            var icon = ths.type
            if (ths.media_type == 'Video') {
                icon = 'video'
            } else if (ths.media_type == 'Audio') {
                icon = 'audio'
            }

            return '/images/documents/' + icon + '_icon.svg'
        }

        var thumb_path = route + '?url=' + encodeURIComponent(ths.full_path)
        thumb_path = ths.width ? thumb_path + '&w=' + ths.width : thumb_path
        thumb_path = ths.height ? thumb_path + '&h=' + ths.height : thumb_path

        return thumb_path
    })()
}

// Make sure our new object extends the generic Object
Media.prototype = Object.prototype
module.exports = Media
